<template>
  <div class="modal-container">
    <vxe-form
        ref="accountFrom"
        title-align="right"
        title-width="110"
        :data="accountData"
        :rules="formRules"
        @submit="submitAccount"
    >
      <vxe-form-item title="户名" field="accountName" span="24">
        <template>
          <div class="grey">{{ accountData.accountName }}</div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="开户行" field="openBankName" span="24">
        <template v-slot="scope">
          <vxe-pulldown ref="bankDown" transfer style="width: 100%">
            <template v-slot>
              <vxe-input
                  v-model="accountData.openBankName"
                  :placeholder="placeholderTxt"
                  @focus="bankFocusEvent"
                  @keyup="bankKeyupEvent"
                  @blur="checkOrg(scope)"
                  style="width: 400px"
              >
                <template #suffix>
                  <div class="input-inner-switch">
                    <em>手动输入</em>
                    <vxe-switch v-model="isInputBank" open-label="是" close-label="否"></vxe-switch>
                  </div>
                </template>
              </vxe-input>
            </template>
            <template v-slot:dropdown>
              <div class="my-dropdown1">
                <div
                    class="list-item1"
                    v-for="item in bankList"
                    :key="item.id"
                    @click="bankSelectEvent(item, scope)"
                >
                  <i class="fa fa-user-o"></i>
                  <span>{{ item.orgName }}</span>
                </div>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-form-item>
      <span class="open-bank-tip"
      ><Icon type="ios-information-circle-outline" />若未查询到开户行，请切换到手动输入</span
      >
      <!-- <vxe-form-item title="手动输入联行号">
        <template>
          <vxe-switch v-model="isInputBank" open-label="是" close-label="否"></vxe-switch>
        </template>
      </vxe-form-item> -->
      <vxe-form-item title="开户行联行号" field="openOrgNum" span="24">
        <template v-slot="scope">
          <vxe-input
              v-model="accountData.openOrgNum"
              placeholder="输入开户行联行号"
              @input="$refs.accountFrom.updateStatus(scope)"
              style="width: 400px"
              :disabled="!isInputBank"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="银行账户号" field="accountNum" span="24">
        <template v-slot="scope">
          <vxe-input
              v-model="accountData.accountNum"
              placeholder="输入银行账户号"
              @input="$refs.accountFrom.updateStatus(scope)"
              style="width: 400px"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item align="center" span="24" style="margin-top: 20px">
        <vxe-button status="primary" style="width: 140px; border-radius: 0px" @click="cancelSubmit"
        >取消</vxe-button
        >
        <vxe-button type="submit" status="primary" style="width: 140px; border-radius: 0px"
        >保存</vxe-button
        >
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts/index";
  import { showLoading, hideLoading, isEmpty } from "@/utils/util";
  import Auth from "@/utils/auth";

  export default {
    name: "AddBankAccount",
    props: ["userId", "userName"],
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      const number = ({ itemValue }) => {
        if (itemValue && itemValue !== "") {
          let reg = /^\d+(?=\.{0,1}\d+$|$)/;
          if (!reg.test(itemValue)) {
            return Promise.reject(new Error("请输入正确的数字"));
          }
          if (itemValue.length > 30) {
            return Promise.reject(new Error("银行账号最大30位"));
          }
        }
      };
      const number2 = ({ itemValue }) => {
        if (itemValue && itemValue !== "") {
          let reg = /^\d+(?=\.{0,1}\d+$|$)/;
          if (!reg.test(itemValue)) {
            return Promise.reject(new Error("请输入正确的数字"));
          }
          if (itemValue.length !== 12) {
            return Promise.reject(new Error("联行号长度错误"));
          }
        }
      };
      return {
        userInfoValue,
        accountData: {
          openOrgNum: null,
        },
        formRules: {
          accountName: [{ required: true, message: "请输入户名" }],
          openBankName: [{ required: true, message: "" }],
          openOrgNum: [{ required: true, message: "请输入联行号" }, { validator: number2 }],
          accountNum: [{ required: true, message: "请输入银行账户号" }, { validator: number }],
        },
        bankList: [],
        chooseBank: false,
        isInputBank: false, //是否手动输入开户行
        openBankName: null,
      };
    },
    watch: {
      isInputBank(newVal, oldVal) {
        // console.log(newVal)
        if (newVal && !this.accountData.openOrgNum) {
          this.accountData.openBankName = this.openBankName;
        }
        if (!newVal && oldVal) {
          this.accountData.openBankName = this.accountData.openOrgNum = this.openBankName = "";
        }
      },
    },
    computed: {
      placeholderTxt() {
        return this.isInputBank ? "请输入开户行" : "请选择开户行";
      },
    },
    methods: {
      checkOrg(scope) {
        if (!this.isInputBank && (!this.accountData.openOrgNum || !this.chooseBank)) {
          this.openBankName = this.accountData.openBankName;
          this.accountData.openBankName = "";
          // this.accountData.openOrgNum = "";
        }
        this.$refs.accountFrom.updateStatus(scope);
      },
      init() {
        this.accountData.signUserId = this.userId;
        this.$set(this.accountData, "accountName", this.userName);
      },
      bankFocusEvent() {
        if (!this.isInputBank) {
          this.$refs.bankDown.showPanel();
        }
      },
      bankKeyupEvent() {
        if (!this.isInputBank) {
          this.chooseBank = false;
          this.getBankListByName();
        }
      },
      bankSelectEvent(obj, scope) {
        this.chooseBank = true;
        this.accountData.openBankName = obj.orgName;
        this.accountData.openOrgNum = obj.orgNum;
        this.$refs.bankDown.hidePanel();
        this.$refs.accountFrom.updateStatus(scope);
      },
      async getBankListByName() {
        let name = this.accountData.openBankName;
        if (isEmpty(name)) {
          this.bankList = [];
          return;
        }
        let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
        if (res.status === 1 && res.message === name) {
          this.bankList = res.data;
        }
      },
      cancelSubmit() {
        this.accountData = {};
        this.$emit("close");
      },
      async submitAccount() {
        let self = this;
        let url = "createUserBank";
        let res = await $api.baseUserSignBank.request(url, this.accountData);
        if (res.status === 1) {
          this.$Message["success"]({
            background: true,
            content: "创建成功",
          });
          this.isInputBank = false;
          this.$emit('successData', this.accountData)
          this.cancelSubmit();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
    },
  };
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .grey {
    color: #b0bac5;
  }
  .input-inner-switch {
    width: 100px;
    position: absolute;
    right: 0;
    top: 0;
    height: 34px;
  }
  .input-inner-switch .vxe-switch {
    position: absolute;
    right: -5px;
    top: 0;
  }
  .input-inner-switch em {
    font-size: 12px;
    height: 100%;
    line-height: 34px;
    display: inline-block;
    color: #606266;
  }
  .open-bank-tip {
    display: block;
    color: #f00;
    padding-left: 110px;
  }
  .my-dropdown1 {
    height: 200px;
    overflow: auto;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
  }
  .list-item1 {
    padding: 5px;
    cursor: pointer;
  }
  .list-item1:hover {
    background-color: #f5f7fa;
  }
</style>
